import { IconButton, PrimaryButton } from "@fluentui/react";
import React, { useContext, useState } from "react";
import { t } from "i18next";
import MobileViewerContext from "../../../../context/studyviewer/MobileViewerContext";
import Chat from "../../../../components/SVGComponents/Chat";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import {
  ADVANCE_VIEWER_MODALITIES,
  REACT_ADVANCE_VIEWER_URL,
  REPORTDONESTATUS,
  SHOW_NOT_ORIGNAL_MODALITY_LIST,
  USERTYPES,
} from "../../../../constants/Constants";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import userContext from "../../../../context/users/UserContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ReturnStudyModal from "../ReturnStudyModal/ReturnStudyModal";
import Copy from "../../../../components/SVGComponents/Copy";
import Compare from "../../../../components/SVGComponents/Tools/Compare";
import Original from "../../../../components/SVGComponents/Tools/Original";
import ReturnedIcon from "../../../../components/SVGComponents/StudyList/Tabs/ReturnedIcon";
import AdvanceViewerSwitch from "../../../../components/SVGComponents/Tools/AdvanceViewerSwitch";
import PreviewStudyListIcon from "../../../../components/SVGComponents/StudyList/Actions/PreviewStudyListIcon";
import ShareIcon from "../../../../components/SVGComponents/ShareIcon";
import ShareStudyContext from "../../../../context/sharestudy/ShareStudyContext";

const MobileBottomSheet = () => {
  const { setOpenMoreOptions } = useContext(MobileViewerContext);
  const {
    activeViewportIndex,
    originalImageActiveState,
    setOriginalImageActiveState,
  } = useContext(ViewportContext);

  const { activeModality } = useContext(ThumbnailContext);
  const { roles } = useContext(userContext);
  const { studyParentAssignmentData, studyModality, firmViewerId, studyParentId, advViewerUser } =
    useContext(studyviewerContext);
  const {
    reportDoneStatusState,
    alreadyLocked,
    setShowReturnStudyModal,
    handlePreviewReport
  } = useContext(studyReportContext);

  const { setShowShareStudyLinkModal } = useContext(ShareStudyContext);

  const handleShowOriginalClick = () => {
    let temp = originalImageActiveState.map((state, index) => {
      if (index === activeViewportIndex) {
        return !state;
      } else return state;
    });
    setOriginalImageActiveState(temp);
    setOpenMoreOptions((prev) => !prev);
  };

  const [changeLockIcon, setChangeLockIcon] = useState(false);

  const checkIfUserAlreadyLocked = () => {
    if (
      studyParentAssignmentData?.qcreviewerId != null &&
      reportDoneStatusState == REPORTDONESTATUS.QC_REVIEW
    ) {
      return false;
    } else if (
      studyParentAssignmentData?.qcverifierId != null &&
      reportDoneStatusState == REPORTDONESTATUS.QC_VERIFY
    ) {
      return false;
    }
    return true;
  };

  const checkForAlreadyLockedOrNot = () => {
    switch (true) {
      case roles[0] === USERTYPES.RADIOLOGIST:
        return !alreadyLocked;

      case roles[0] === USERTYPES.SUPERVISOR:
        if (!changeLockIcon) {
          if (
            studyParentAssignmentData?.qcreviewerId == null &&
            studyParentAssignmentData?.qcverifierId == null
          ) {
            return true;
          } else {
            return checkIfUserAlreadyLocked();
          }
        } else {
          return false;
        }
      default:
        return false;
    }
  };

  return (
    <div className="popup-viewer-content">
      {/* Filter options */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "15%",
          borderBottom: "1px solid #3D3D3D",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <span className="study-list-mobile-filter-txt">More Options</span>
        <div className="study-list-mobile-close-icon-div">
          <IconButton
            //style={{ color: "white" }}
            //style={{color : "var(--navbar-header-popup-color-txt)"}}
            style={{color : "var(--mobile-color-txt)"}}
            iconProps={{ iconName: "Cancel" }}
            ariaLabel="Close popup filter mobile"
            onClick={() => setOpenMoreOptions(false)}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-evenly",
          flexDirection: "column",
          height: "70%",
          borderBottom: "1px solid #3D3D3D",
        }}
      >
        {!SHOW_NOT_ORIGNAL_MODALITY_LIST.includes(activeModality) && (
          <span
            className="more-options-option"
            onClick={handleShowOriginalClick}
          >
            <Original />
            <span className="more-options-option-text">
              {originalImageActiveState[activeViewportIndex]
                ? "Show Downsize"
                : "Show Original"}
            </span>
          </span>
        )}
        {roles[0] === USERTYPES.RADIOLOGIST &&
          !checkForAlreadyLockedOrNot() && (
            <span
              style={{ paddingLeft: "8px" }}
              className="more-options-option"
              onClick={() => {
                setShowReturnStudyModal(true);
                setOpenMoreOptions(false);
              }}
            >
              <ReturnedIcon />
              <span className="more-options-option-text">Return Study</span>
            </span>
          )}
        {advViewerUser && ADVANCE_VIEWER_MODALITIES.includes(studyModality) && (
          <span
            className="more-options-option"
            onClick={() => {
              window.open(
                REACT_ADVANCE_VIEWER_URL + studyParentId + "?firmId=" + firmViewerId,
                "_self"
              );
            }}
          >
            <AdvanceViewerSwitch color={"#bfbfbf"} />
            <span className="more-options-option-text">
              Switch to Advance Viewer
            </span>
          </span>
        )}
        <span
          className="more-options-option"
          style={{ paddingLeft: "12px" }}
          onClick={() => setShowShareStudyLinkModal((prev) => !prev)}
        >
          <ShareIcon color={"#bfbfbf"} />
          <span className="more-options-option-text">Share Study</span>
        </span>

        {(roles[0] == USERTYPES.FIRMADMIN ||
          roles[0] == USERTYPES.ADMIN ||
          roles[0] == USERTYPES.RADIOLOGIST ||
          roles[0] == USERTYPES.SUPERVISOR) &&
          (reportDoneStatusState == 1 || reportDoneStatusState == 2) && (
            <>
              <span
                className="more-options-option"
                style={{ paddingLeft: "12px" }}
                onClick= {() => handlePreviewReport(studyParentId, reportDoneStatusState)}
              >
                <PreviewStudyListIcon color={"#bfbfbf"} />
                <span className="more-options-option-text">Preview Report</span>
              </span>
            </>
          )}
      </div>
    </div>
  );
};

export default MobileBottomSheet;
